// Centralized plan configuration
const ALL_FEATURES = [
  "Real-time GPS tracking",
  "Biometric face verification",
  "GPS geofence check-in",
  "QR code checkpoints",
  "Hourly scheduling & patrol routes",
  "Full check-in & incident logs",
  "AI incident analysis",
  "Multi-site dashboard",
  "Officer management panel",
  "Live GPS map with trails",
  "Advanced analytics & reporting",
  "Shift password management",
  "Risk management module",
  "Timesheet & shift clock",
  "Email & priority support",
];

export const PLANS = [
  {
    key: "core",
    name: "CORE",
    price: "$10",
    desc: "Up to 5 officers across 2 sites",
    maxOfficers: 5,
    maxSites: 2,
    features: [...ALL_FEATURES],
    popular: false,
  },
  {
    key: "professional",
    name: "PROFESSIONAL",
    price: "$20",
    desc: "Up to 15 officers across 5 sites",
    maxOfficers: 15,
    maxSites: 5,
    features: [...ALL_FEATURES],
    popular: false,
  },
  {
    key: "essential_pro",
    name: "ESSENTIAL PRO",
    price: "$45",
    desc: "Unlimited officers & sites",
    maxOfficers: Infinity,
    maxSites: Infinity,
    features: [...ALL_FEATURES, "Dedicated account manager"],
    popular: true,
  },
] as const;

export type PlanKey = (typeof PLANS)[number]["key"];

export function getPlan(planKey: string | undefined | null) {
  if (!planKey) return PLANS[0]; // default to core
  const normalized = planKey.toLowerCase().replace(/[\s-]/g, "_");
  return PLANS.find((p) => p.key === normalized) || PLANS[0];
}

export function getPlanPrice(planKey: string | undefined | null): string {
  return getPlan(planKey).price;
}

export function canAddOfficer(planKey: string | undefined | null, currentCount: number): boolean {
  const plan = getPlan(planKey);
  return currentCount < plan.maxOfficers;
}

export function canAddSite(planKey: string | undefined | null, currentCount: number): boolean {
  const plan = getPlan(planKey);
  return currentCount < plan.maxSites;
}

export function getLimitMessage(planKey: string | undefined | null, type: "officer" | "site"): string {
  const plan = getPlan(planKey);
  const limit = type === "officer" ? plan.maxOfficers : plan.maxSites;
  if (limit === Infinity) return "";
  return `Your ${plan.name} plan allows up to ${limit} ${type}${limit !== 1 ? "s" : ""}. Upgrade to add more.`;
}
